export default __webpack_public_path__ + "static/media/property_105.30679668.png";